var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReponsiveMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.156,
    height: 33.156,
    viewBox: "0 0 33.156 33.156",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "menu_2_",
    "data-name": "menu(2)",
    d: "M29.1,0H4.06A4.065,4.065,0,0,0,0,4.06V29.1a4.065,4.065,0,0,0,4.06,4.06H29.1a4.065,4.065,0,0,0,4.06-4.06V4.06A4.065,4.065,0,0,0,29.1,0Zm1.988,29.1A1.99,1.99,0,0,1,29.1,31.084H4.06A1.99,1.99,0,0,1,2.072,29.1V4.06A1.99,1.99,0,0,1,4.06,2.072H29.1A1.99,1.99,0,0,1,31.084,4.06Zm-5.31-4.358a1.036,1.036,0,0,1-1.036,1.036H8.419a1.036,1.036,0,1,1,0-2.072H24.738A1.036,1.036,0,0,1,25.774,24.738Zm0-8.16a1.036,1.036,0,0,1-1.036,1.036H8.419a1.036,1.036,0,0,1,0-2.072H24.738A1.036,1.036,0,0,1,25.774,16.578Zm0-8.16a1.036,1.036,0,0,1-1.036,1.036H8.419a1.036,1.036,0,0,1,0-2.072H24.738A1.036,1.036,0,0,1,25.774,8.419Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReponsiveMenu);
export default __webpack_public_path__ + "static/media/reponsive_menu.68b5913a7a32f4b35d193cdc5e576475.svg";
export { ForwardRef as ReactComponent };